import { render, staticRenderFns } from "./oilHotalOrderConfirm.vue?vue&type=template&id=b9ed30ac&scoped=true&"
import script from "./oilHotalOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./oilHotalOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./oilHotalOrderConfirm.vue?vue&type=style&index=0&id=b9ed30ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ed30ac",
  null
  
)

export default component.exports